import { useCallback, useEffect, useRef, useState } from "react";

/**
 * Tabovi se montiraju tek kad se prvi put otvore (lazy), pa je ref kartice na neaktivnom tabu
 * još uvijek null. Kad akcija iz izbornika ("Dokumentacija → Najam → Ponuda") treba otvoriti
 * modal s drugog taba, prvo se prebaci tab, a otvaranje se izvrši kad se kartica montira.
 */
export const useOpenOnTab = () => {
  const [activeTab, setActiveTab] = useState<number>(0);
  // Trenutni tab se čita i izvan rendera — postavljanje istog indeksa ne bi pokrenulo efekt.
  const activeTabRef = useRef<number>(0);
  const pendingAction = useRef<(() => void) | null>(null);

  const openOnTab = useCallback((tabIndex: number, action: () => void) => {
    if (activeTabRef.current === tabIndex) {
      // Tab je već otvoren, kartica je montirana — akcija ide odmah.
      action();
      return;
    }

    pendingAction.current = action;
    setActiveTab(tabIndex);
  }, []);

  useEffect(() => {
    activeTabRef.current = activeTab;

    if (!pendingAction.current) return;

    // Sadržaj taba postoji tek nakon rendera koji je promijenio aktivni tab.
    const timeoutId = setTimeout(() => {
      pendingAction.current?.();
      pendingAction.current = null;
    }, 0);

    return () => clearTimeout(timeoutId);
  }, [activeTab]);

  return { activeTab, setActiveTab, openOnTab };
};
